/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createIsInteger } from '../../factoriesAny.js';
export var isIntegerDependencies = {
  typedDependencies,
  createIsInteger
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesIsInteger.generated.js
// module id = psY1
// module chunks = 3